import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

let metaCache = null;

// Group + sub-group narrowing for item pickers; sub-groups follow the chosen group.
export function ItemPickerFilters({ value, onChange, testid }) {
  const [meta, setMeta] = useState(metaCache);
  useEffect(() => {
    if (!metaCache) api.get("/items/meta").then((r) => { metaCache = r.data; setMeta(r.data); }).catch(() => {});
  }, []);
  const subs = meta ? (value.group ? meta.group_subs?.[value.group] || [] : meta.sub_groups || []) : [];
  const groups = useMemo(() => Object.keys(meta?.group_subs || {}).sort(), [meta]);
  const cls = "h-8 min-w-0 flex-1 rounded border border-slate-200 bg-white px-2 text-xs text-slate-700";
  return (
    <div className="flex gap-2 border-b border-slate-200 p-2" data-testid={`${testid}-filters`}>
      <select className={cls} value={value.group} onChange={(e) => onChange({ group: e.target.value, sub_group: "" })} data-testid={`${testid}-group-filter`}>
        <option value="">All groups</option>
        {groups.map((g) => <option key={g} value={g}>{g}</option>)}
      </select>
      <select className={cls} value={value.sub_group} onChange={(e) => onChange({ ...value, sub_group: e.target.value })} data-testid={`${testid}-subgroup-filter`}>
        <option value="">All sub-groups</option>
        {subs.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
    </div>
  );
}
